import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

export const enabledFeaturesSelector = (state: RootState) => state.user.loggedUser.enabledFeatures;
// transform permissions list from flat array "[1, 2, 3]" into a dictionary "{1: true, 2: true, 3: true}"
// to reduce complexity
export const enabledFeaturesDictionarySelector = createSelector([enabledFeaturesSelector], (features = []) =>
  features.reduce((acc: Record<number, boolean>, item: number) => {
    acc[item] = true;
    return acc;
  }, {})
);
